<!--  -->
<template>
  <div class="agreement_c">
    <div class="main_title">神州邦邦招聘职位信息发布规则</div>
    <div class="main_item">
      <h2>一、&nbsp;前言</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            本《神州邦邦平台招聘职位信息发布规则》（以下简称“规则”）系您（指个人或组织）与北京神州邦邦技术服务有限公司（以下简称“神州邦邦平台”、“邦邦招聘”或“本平台”）订立的《神州邦邦平台服务协议》的有效组成部分，与《神州邦邦平台服务协议》共同构成您与北京神州邦邦技术服务有限公司合作的法律文件。
          </p>
        </li>
        <li>
          <p>
            您在使用神州邦邦平台填写并发布企业信息、职位信息之前，请务必审慎阅读、充分理解本规则。您使用神州邦邦平台招聘职位信息发布服务的行为，即表示您已阅读并同意本规则所涉全部内容。
          </p>
        </li>
        <li>
          <p>
            神州邦邦平台有权根据法律法规、政策及产品需求更新本规则，请您定期访问并查看最新规则。如您继续使用神州邦邦平台招聘服务的，即表示您接受经修订后的规则。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>二、&nbsp;禁止发布的职位信息</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            基于合法性、安全性、真实性、有效性等原则考虑，目前神州邦邦平台不提供包含以下信息的职位发布服务，若您发布的职位信息包含以下内容，可能将随时被驳回、下架（部分或全部屏蔽、删除）：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>违法及不良类信息；</p>
            </li>
            <li>
              <p>包含违法、政治敏感内容；</p>
            </li>
            <li>
              <p>包含色情、淫秽、性暗示或三俗内容，如寻找伴侣、寻求包养等；</p>
            </li>
            <li>
              <p>
                包含违反《劳动合同法》等相关法律法规规定的内容，如低于最低工资要求等；
              </p>
            </li>
            <li>
              <p>包含性别歧视或指向性歧视、地域歧视等；</p>
            </li>
            <li>
              <p>包含人身攻击或其他侵害他人权益的内容；</p>
            </li>
            <li>
              <p>虚假/不明确的信息；</p>
            </li>
            <li>
              <p>包含不真实的公司信息；</p>
            </li>
            <li>
              <p>包含虚假的招聘者身份信息；</p>
            </li>
            <li>
              <p>包含不真实的职位描述、工作内容、薪资或工作地点；</p>
            </li>
            <li>
              <p>职位类型与职位描述或与公司经营范围不符的；</p>
            </li>
            <li>
              <p>职位名称与职位描述不明确的；</p>
            </li>
            <li>
              <p>职位名称包含职位名称以外信息的；</p>
            </li>
            <li>
              <p>一个岗位发布多个职位或重复发布相同职位情节严重的；</p>
            </li>
            <li>
              <p>发布的职位信息与实际所招聘职位不符；</p>
            </li>
            <li>
              <p>包含广告、寻求合作、传销、直销等内容；</p>
            </li>
            <li>
              <p>包含微信号、QQ号、手机号等第三方社交账号(或链接)内容；</p>
            </li>
            <li>
              <p>包含鸡汤、段子、水贴等与招聘无关的信息；</p>
            </li>
            <li>
              <p>违规或高风险类信息；</p>
            </li>
            <li>
              <p>兼职模特、试衣模特类职位；</p>
            </li>
            <li>
              <p>无经验交易员、分析师类职位；</p>
            </li>
            <li>
              <p>涉及套路贷类职位；</p>
            </li>
            <li>
              <p>跟剧组类职位；</p>
            </li>
            <li>
              <p>演员、练习生、歌手类职位；</p>
            </li>
            <li>
              <p>夜场等娱乐会所类职位；</p>
            </li>
            <li>
              <p>涉及出海类的职位，如船员、出海捕捞岗位等；</p>
            </li>
            <li>
              <p>工作地点不在中国境内的职位；</p>
            </li>
            <li>
              <p>涉及异地培训/实习的保安类职位；</p>
            </li>
            <li>
              <p>信用卡套现类职位；</p>
            </li>
            <li>
              <p>淘宝刷单、微商代理、手机兼职、手工兼职类职位；</p>
            </li>
            <li>
              <p>游戏代练类职位；</p>
            </li>
            <li>
              <p>涉及发布代孕、捐精、捐卵业务；</p>
            </li>
            <li>
              <p>
                涉及恶意招聘大量（5个以上）兼职主播类职位，内容涉及陪玩陪聊；
              </p>
            </li>
            <li>
              <p>挂靠类职位；</p>
            </li>
            <li>
              <p>部分涉及保险业务的职位（内测用户除外）；</p>
            </li>
            <li>
              <p>兼职推广或为其他平台拉用户的职位；</p>
            </li>
            <li>
              <p>涉及网络发行、销售彩票类职位；</p>
            </li>
            <li>
              <p>有涉黄倾向的模特类的职位；</p>
            </li>
            <li>
              <p>涉及违规网约车司机、送餐员/外卖骑手的职位；</p>
            </li>
            <li>
              <p>被多位用户举报的职位；</p>
            </li>
            <li>
              <p>涉及体验师类的职位（含兼职），例如旅游体验师等；</p>
            </li>
            <li>
              <p>
                涉及发布超越正常工作范围的职位，或职位信息涉及私密关系的情况，如：陪酒、陪吃、陪住、陪玩、陪聊等；
              </p>
            </li>
            <li>
              <p>其他存在高风险及不符合产品政策的职位。</p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>三、&nbsp;禁止实施的行为</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            本平台严禁用户在发布、开聊、邀约或等各项环节，实施下述行为。如您/您的关联账号存在下述行为，您的职位信息（免费、付费）均有可能无法审核通过或被删除/屏蔽；您的账号可能被暂时或永久冻结：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                实施任何辱党、辱国、传播邪教思想等违法及违背公序良俗的行为；
              </p>
            </li>
            <li>
              <p>在平台内使用涉及各国政治人物的图片；</p>
            </li>
            <li>
              <p>在平台内使用含色情、淫秽内容的图片；</p>
            </li>
            <li>
              <p>在平台内使用人身攻击或其他侵害他人权益的图片；</p>
            </li>
            <li>
              <p>
                通过非神州邦邦开发、授权的第三方软件、插件、外挂或系统或其他不正常的方式，登录、使用神州邦邦平台招聘服务，影响或可能影响神州邦邦平台招聘服务管理运营秩序的；
              </p>
            </li>
            <li>
              <p>
                以培训费、服装费、工作需要等任何名义向求职者索要财物、收取求职者费用、引导求职者贷款、引导求职者入金等；
              </p>
            </li>
            <li>
              <p>实施传销活动或骗取他人加入传销组织；</p>
            </li>
            <li>
              <p>
                招聘他人从事违法违规、违背公序良俗的活动，包括但不限于学术造假、作弊、替考、刷单、赌博等；
              </p>
            </li>
            <li>
              <p>直接或变相索取其他用户个人信息的行为；</p>
            </li>
            <li>
              <p>骚扰其他用户；</p>
            </li>
            <li>
              <p>
                利用平台可能存在的漏洞进行“撸羊毛”、恶意获取“邦豆”“服务费减免券”等道具产品、在第三方售卖前述道具产品；
              </p>
            </li>
            <li>
              <p>在平台内使用涉及广告（寻求合作）、营销的头像或宣传图片；</p>
            </li>
            <li>
              <p>无RPO业务但帮其他公司招聘的行为；</p>
            </li>
            <li>
              <p>以招聘名义招人培训；</p>
            </li>
            <li>
              <p>个体工商户发布异地职位的行为；</p>
            </li>
            <li>
              <p>所招聘岗位无薪资或存在涉及拒发或恶意拖欠工资的行为；</p>
            </li>
            <li>
              <p>招聘未满16周岁人员；</p>
            </li>
            <li>
              <p>
                发布涉及违规网约车司机、违规送餐员/外卖骑手等相关信息的行为；
              </p>
            </li>
            <li>
              <p>
                未通过平台功能与用户交换联系方式或诱导用户站外求职招聘，例如发送包含社交账号/通信方式（例如微信号/QQ号/手机号/第三方网站链接等）的开聊信息、发布包含前述内容的职位；
              </p>
            </li>
            <li>
              <p>
                其他违反法律法规、违背公序良俗、对抗平台规则、破坏平台秩序等不当行为。
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>四、&nbsp;企业信息发布规则</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            您可以在神州邦邦平台招聘中心提供企业信息，以提升您公司对求职者的吸引力，当提供公司详细信息时，您应当确保填写的企业相关信息合法、真实、准确，您发布的所有文字、图片、视频等内容，都不得含有任何违法、政治敏感、不符合公序良俗、侵犯他人权益的内容。
          </p>
        </li>
        <li>
          <p>
            在您填写或修改已有的企业相关信息时，应当遵守的具体规则包括但不限于：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                企业名称、品牌名称、LOGO应当真实有效；品牌名称、LOGO应当与该企业主体具有一致性，或有合法授权；
              </p>
            </li>
            <li>
              <p>
                品牌名称不得与其他知名品牌名称相同或近似，不得侵犯其他第三方的知识产权等合法权益；
              </p>
            </li>
            <li>
              <p>
                公司LOGO应当与公司经营过程中实际使用的LOGO一致，且与其他品牌的使用在先的LOGO不相同或近似；
              </p>
            </li>
            <li>
              <p>公司经营地址应当真实有效，如发生变化应当及时更新；</p>
            </li>
            <li>
              <p>公司网址应当真实有效，如发生变化应当及时更新；</p>
            </li>
            <li>
              <p>
                在公司介绍主页上，不得上传与公司无关的图片或涉及联系方式的内容；
              </p>
            </li>
            <li>
              <p>
                公司介绍的文字内容应当真实、准确、完整，便于求职者理解，不得发布与公司介绍无关的文字内容；
              </p>
            </li>
            <li>
              <p>公司介绍中包含的经营内容应当与公司的经营范围存在一致性；</p>
            </li>
            <li>
              <p>
                产品介绍应当真实、准确、完整，不得将他人产品或产品介绍挪为己用，相关产品应符合公司的经营范围要求；
              </p>
            </li>
            <li>
              <p>
                提供的高管或个人图片应当真实可辨，不得将他人的照片或无关的图片作为高管照片或个人照片；
              </p>
            </li>
            <li>
              <p>
                您发布的信息中不得包含任何其他个人的隐私信息或其他公司的商业信息，不得侵犯其他第三方的合法权益。
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>五、&nbsp;暂不提供服务的企业类型</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            基于合法性、安全性、真实性、效率性及产品政策等原因，神州邦邦平台暂不为存在以下情况的公司提供职位发布服务。因此，您可能无法发布此类公司的介绍信息，无法发布相关的职位信息，或/和该信息在发布后被平台驳回/删除/屏蔽/下架：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>所招聘岗位无薪资或公司存在涉及拒发或恶意拖欠工资的公司；</p>
            </li>
            <li>
              <p>涉及以招聘名义招人培训的公司；</p>
            </li>
            <li>
              <p>存在刷单、微商代理、手机兼职、手工兼职业务的公司；</p>
            </li>
            <li>
              <p>存在跟剧组行为的公司；</p>
            </li>
            <li>
              <p>存在兼职模特、试衣模特业务的公司；</p>
            </li>
            <li>
              <p>存在培养演员、练习生、歌手业务的公司；</p>
            </li>
            <li>
              <p>存在需要求职者去境外工作的公司；</p>
            </li>
            <li>
              <p>主营业务为夜场等娱乐场所的公司；</p>
            </li>
            <li>
              <p>涉及收取求职者费用、引导求职者贷款、引导求职者入金的公司；</p>
            </li>
            <li>
              <p>涉及色情、淫秽、性暗示或三俗内容的公司；</p>
            </li>
            <li>
              <p>存在直销或传销模式业务的公司；</p>
            </li>
            <li>
              <p>存在信用卡套现的公司；</p>
            </li>
            <li>
              <p>存在挂靠业务的公司；</p>
            </li>
            <li>
              <p>存在涉及套路贷业务的公司；</p>
            </li>
            <li>
              <p>
                在国家企业信用信息公示系统中的登记状态为注销/吊销状态的公司；
              </p>
            </li>
            <li>
              <p>
                在国家企业信用信息公示系统中被列入经营异常名录，情节严重的公司；
              </p>
            </li>
            <li>
              <p>在国家企业信用信息公示系统中查询不到注册信息的公司；</p>
            </li>
            <li>
              <p>已被法院判定为破产或正在进行破产申请流程的公司；</p>
            </li>
            <li>
              <p>
                在媒体、网站或社交平台等渠道中查询到涉嫌存在严重失信、违法违规或违反平台规则等相关行为的公司；
              </p>
            </li>
            <li>
              <p>被多位用户举报的公司；</p>
            </li>
            <li>
              <p>涉及代孕、捐精、捐卵的业务的公司；</p>
            </li>
            <li>
              <p>涉及恶意招聘大量兼职主播或业务涉及陪玩陪聊的公司；</p>
            </li>
            <li>
              <p>涉及招聘无经验交易员、分析师的公司；</p>
            </li>
            <li>
              <p>
                涉及猎头业务、招聘流程外包等人力资源服务或为第三方招聘的公司（人才经纪人除外）；
              </p>
            </li>
            <li>
              <p>涉及保险业务的公司（除内测用户以外）；</p>
            </li>
            <li>
              <p>存在涉及虚拟/数字货币交易的公司；</p>
            </li>
            <li>
              <p>涉及兼职推广或为其他平台拉用户等业务的公司；</p>
            </li>
            <li>
              <p>涉嫌从事网络发行、销售彩票相关业务的公司；</p>
            </li>
            <li>
              <p>涉嫌非法经营或从事违法违规、违背公序良俗业务的公司；</p>
            </li>
            <li>
              <p>发布模特职位且有涉黄倾向的公司；</p>
            </li>
            <li>
              <p>发布异地培训/实习的保安职位的公司；</p>
            </li>
            <li>
              <p>发布违规网约车司机、送餐员/外卖骑手职位的公司；</p>
            </li>
            <li>
              <p>发布涉及体验师类职位（含兼职）的公司，例如旅游体验师等；</p>
            </li>
            <li>
              <p>发布涉及出海类职位的公司，例如船员、出海捕捞岗位等；</p>
            </li>
            <li>
              <p>
                发布超越正常工作范围的职位，或职位信息包含私密关系的公司，如在职位描述中包括陪酒、陪吃、陪住、陪玩、陪聊等；
              </p>
            </li>
            <li>
              <p>
                其他经营违法违规业务或基于风控策略/安全风险/产品政策等原因无法提供服务的公司。
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>六、&nbsp;违规处罚规则</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            神州邦邦平台有权对用户发布的企业信息、职位信息进行审核，对于不符合本规则的内容，有权采取拒绝发布、部分或全部删除等处理措施。
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                用户违反前述第二条、第三条、第四条规定的内容，或者有其他可能损害神州邦邦平台利益或违法行为的，本平台有权视情节采取，包括但不限于冻结您的账户的方式暂时乃至永久停止您使用神州邦邦平台招聘服务且不做解封与退款处理、禁言、限制部分或全部功能的使用、取消预约面试等相关处理措施。如用户行为涉嫌违法犯罪的，神州邦邦平台有权向有关行政机关及司法部门举报、披露相关信息。
              </p>
            </li>
            <li>
              <p>
                您或您的关联账号涉嫌违反本规则，或者有其他明显损害本平台利益或违法行为的，经本平台发现或用户投诉后核实的，本平台有权视情节采取冻结账户的方式暂时乃至永久停止您使用神州邦邦平台招聘服务且不做解封与退款处理。
              </p>
            </li>
            <li>
              <p>
                如您的行为给本平台造成损失的，本平台有权要求您赔偿全部的损失；如涉嫌违法犯罪的，本平台有权向有关行政机关及司法部门举报、披露相关信息。
              </p>
            </li>
            <li>
              <p>
                如违反本规则的情节严重的，本平台有权冻结该企业账号，即不为该企业提供相关服务。
              </p>
            </li>
            <li>
              <p>
                为防止信息泄露，保障神州邦邦平台的稳定及安全，任何用户不得使用任何相关招聘管理系统/插件/外挂/工具/ATS，包括但不限于北森、大易、moka、图谱、云招、e成等，访问或接入神州邦邦平台系统及获取神州邦邦平台免费及付费服务（包括但不限于登录神州邦邦平台账号、发布职位、浏览职位、收发简历、筛选匹配等）同时，用户不得制作、发布、传播上述插件/外挂/工具，无论以任何目的。用户违反本规则的，本平台可以依据本规则直接采取相关措施，并视情节严重程度选择是否通知用户。接到通知的用户可以通过“锁定通知”页面显示的渠道向本平台提交申诉。
              </p>
            </li>
            <li>
              <p>
                两个用户名下认证的账号，被系统判定是关联账号的，如其中一个账号因违法违规被冻结的，其他关联账号均将被同时冻结。
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>七、&nbsp;其他规则</h2>
      <ul class="content_wrap1">
        <li>
          <p>定义：</p>
          <ul class="content_wrap2">
            <li>
              <p>
                本规则所称“异地职位”指工作地点与招聘主体（指招聘企业提交营业执照并审核通过）营业执照地址不一致或不在同一城市的招聘信息。
              </p>
            </li>
            <li>
              <p>
                所有职位均设置了有效期限，本平台有权对不同的职位类别下职位信息设置不同的有效期，有效期届满时该职位信息可能被下线。
              </p>
            </li>
            <li>
              <p>
                本平台有权根据法律法规、政策及产品需求更新本规则，并在平台内予以公布。新的规则自公布之日起生效。如您不同意变更事项，您应当于变更事项确定的生效之日起停止使用神州邦邦平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用神州邦邦平台服务，则视为您同意已生效的变更事项。
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>